import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { FEE_PROVIDER_TYPE } from '../actions';

const initialState = {};

const feeProviderReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case FEE_PROVIDER_TYPE.GET_PROVIDERS:
        return payload || state;

      case FEE_PROVIDER_TYPE.CREATE_PROVIDER:
      case FEE_PROVIDER_TYPE.UPDATE_PROVIDER:
        draft[payload.feeProviderId] = payload;
        break;

      case FEE_PROVIDER_TYPE.DELETE_PROVIDER:
        delete draft[meta.feeProviderId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default feeProviderReducer;
